// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";

const name = "prefixSumScanBlockComputeShader";
const shader = `struct Params {count : u32,};@group(0) @binding(0) var<storage,read_write> data : array<u32>;@group(0) @binding(1) var<storage,read_write> blockSums : array<u32>;@group(0) @binding(2) var<uniform> params : Params;var<workgroup> temp : array<u32,256>;@compute @workgroup_size(256,1,1)
fn main(@builtin(global_invocation_id) gid : vec3u,@builtin(local_invocation_id) lid : vec3u,@builtin(workgroup_id) wid : vec3u) {let g=gid.x;let t=lid.x;var v=0u;if (g<params.count) {v=data[g];}
temp[t]=v;workgroupBarrier();for (var d=1u; d<256u; d=d*2u) {var val=temp[t];if (t>=d) {val=val+temp[t-d];}
workgroupBarrier();temp[t]=val;workgroupBarrier();}
if (g<params.count) {data[g]=temp[t]-v;}
if (t==255u) {blockSums[wid.x]=temp[t];}}
`;
// Sideeffect
if (!ShaderStore.ShadersStoreWGSL[name]) {
    ShaderStore.ShadersStoreWGSL[name] = shader;
}

/** @internal */
export const prefixSumScanBlockComputeShaderWGSL = { name, shader };
